import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from "@angular/core";
import {PriceRule} from "@app/models/price-rule";
import {PackageModel} from "@app/@core/domain/package.model";
import {midNight} from "@shared/helper/helpers";
import {groupBy, orderBy} from "lodash-es";
import {isPriceRuleActive} from "@app/modules/price-rule/price-rule-helper";


@Component({
    selector: 'app-package-info-tables',
    template: `
        <ng-container>
            <p-fieldset legend="Active">
                <app-package-info-table [items]="actives" (rowClick)="onRowClick($event)"></app-package-info-table>
            </p-fieldset>

            <br>

            <p-fieldset legend="Inactive ({{inActives?.length}} rules)" toggleable="true" [collapsed]="collapsed">
                <app-package-info-table [items]="inActives" (rowClick)="onRowClick($event)"></app-package-info-table>
            </p-fieldset>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageInfoTablesComponent implements OnInit, OnChanges {
    @Input() items: PackageModel.PackageInfo[];
    @Input() collapsed = true;

    @Output() rowClick = new EventEmitter<PackageModel.PackageInfo>();

    actives: PackageModel.PackageInfo[] = [];
    inActives: PackageModel.PackageInfo[] = [];

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.items && Array.isArray(this.items)) {
            this.actives = this.items.filter(item => item.active === true);
            this.inActives = this.items.filter(item => item.active === false);
        } else {
            this.actives = [];
            this.inActives = [];
        }
    }

    onRowClick($event: PackageModel.PackageInfo) {
        this.rowClick.emit($event);
    }
}
